"use client";

/**
 * The browser's choice on the privacy page: the same two answers as the
 * question (shell/ConsentDialog), side by side and alike, the current one
 * marked as such. A press posts it and the page comes back with it, through
 * the shell's one lock like every other write (`usePendingRefresh`).
 */
import { useState } from "react";
import { usePendingRefresh } from "@/components/shell/NavigationPending";
import { t, type Lang } from "@/lib/i18n/index";

export function PrivacyChoice({ lang, choice }: { lang: Lang; choice: "granted" | "denied" | null }) {
  const s = t(lang);
  const pending = usePendingRefresh();
  const [busy, setBusy] = useState(false);
  async function choose(analytics: "granted" | "denied") {
    if (busy) return;
    const operation = pending.begin();
    if (!operation) return;
    setBusy(true);
    try {
      const res = await fetch("/api/consent", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ analytics, where: "privacy" }) });
      if (!res.ok) {
        console.error("[privacy] consent", res.status);
        return;
      }
      await operation.refresh();
    } catch (err) {
      console.error("[privacy] consent", err);
    } finally {
      operation.release();
      setBusy(false);
    }
  }
  return (
    <div className="consent-answers">
      <button type="button" className="btn" aria-pressed={choice === "denied"} disabled={busy} data-consent-answer="denied" onClick={() => choose("denied")}>{s["consent.no"]}</button>
      <button type="button" className="btn" aria-pressed={choice === "granted"} disabled={busy} data-consent-answer="granted" onClick={() => choose("granted")}>{s["consent.yes"]}</button>
    </div>
  );
}
